import styled, { css } from 'styled-components';
import colors from 'UIKit/Colors';
import mq from 'UIKit/Mq';

import WinterBg from '@/assets/img/WinterBg.png';

const Panel = styled.div.attrs(props => ({
  className: props.className,
  style: props.style,
}))`
  position: relative;
  padding: 25px;
  min-height: 100%;
  width: 100%;
  border-radius: 20px;
  background-color: ${colors.white['0']};
  display: flex;
  flex-direction: column;
  ${mq.tablet`
    padding: 12px;
    `};
  ${({ table }) =>
    table &&
    css`
      max-width: 100vw;
      overflow-x: auto;
      ${mq.desktop1366`
      	max-width: 100vw;
      `};
      ${mq.desktop1200`
      	max-width: 100vw;
      `};
      ${mq.tabletHorizontal`
      	max-width: 100vw;
      `};
      ${mq.tablet`
      	max-width: 100vw;
      `};
    `};
  ${({ green }) =>
    green &&
    css`
      background-image: linear-gradient(-225deg, #1de9b6 0%, #1dc4e9 100%);
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
    `};
  ${({ winter }) =>
    winter &&
    css`
      background: url(${WinterBg});
      background-color: #fff;
      background-repeat: no-repeat;
      background-position: top;
      background-size: 100% auto;
    `};
`;

export default Panel;
